const PLATFORM = {
  Wechat: 'Wechat',
  PPTV: 'PPTV',
  PPSports: 'PPSports',
  SNEbuy: 'SNEbuy',
  SNYifubao: 'SNYifubao',
  Browser: 'Browser',
  Zhifubao: 'Zhifubao',
  SNSmartIOT: 'SNSmartIOT',
  Harmony: 'Harmony'
};
const UA = window.navigator.userAgent;
const UP = window.navigator.platform;

function isBrowser() {
  return typeof window !== 'undefined';
}

function getPlatform() {
  if (!isBrowser()) {
    return undefined;
  }
  const check = {
    isWechat() {
      return UA.toLowerCase().match(/MicroMessenger/i);
    },
    isPPTVSports() {
      return /pptvsports/i.test(UA);
    },
    isPPTV() {
      return /pptv/i.test(UA) && !/pptvsports/i.test(UA);
    },
    isSNEbuy() {
      return /snebuy/i.test(UA);
    },
    isSNYifubao() {
      return /snyifubao/i.test(UA);
    },
    isZhifubao() {
      return UA.toLowerCase().match(/AlipayClient/i);
    },
    isSuningSmart() {
      return UA.toLowerCase().match(/SmartIOT/i);
    },
    isHarmony() {
      return /Harmony/i.test(UA);
    }
  };
  if(check.isHarmony()){
    return PLATFORM.Harmony;
  }
  if (check.isWechat()) {
    return PLATFORM.Wechat;
  }
  if (check.isPPTVSports()) {
    return PLATFORM.PPSports;
  }
  if (check.isPPTV()) {
    return PLATFORM.PPTV;
  }
  if (check.isSNEbuy()) {
    return PLATFORM.SNEbuy;
  }
  if (check.isSNYifubao()) {
    return PLATFORM.SNYifubao;
  }
  if (check.isZhifubao()) {
    return PLATFORM.Zhifubao;
  }
  if (check.isSuningSmart()) {
    return PLATFORM.SNSmartIOT;
  }
  return PLATFORM.Browser;
}

const platform = getPlatform();

/**
 * 判断设备和操作系统
 */
const isMobile = UA.includes('Mobile'); // 是否移动端
const winPc = UP.toUpperCase().includes('WIN') && !isMobile; // windows pc
const macPc = UP.toUpperCase().includes('MAC') && !isMobile; // mac pc

const isPPTVClient = (UA.toUpperCase().includes('PPTV') || UA.toUpperCase().includes('PPMVP')) && !isMobile; // pptv 客户端
const isSulinkClient = UA.toUpperCase().includes('SULINK') && !isMobile; // 苏小拍客户端
const isClient = isPPTVClient || isSulinkClient; // 是否客户端

const RUNTIME_ENV = {
  ios: !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && isMobile, // 移动ios终端
  android: UA.includes('Android') && isMobile, // 移动android终端
  harmony: UA.includes('Harmony') && isMobile, // 移动android终端

  webWin: winPc && !isClient,
  webMac: macPc && !isClient,

  clientWin: winPc && isClient,
  clientMac: macPc && isClient,
};

/**
 * 208000202035 手机-Android-Wap-聚力视频
   208000201035 手机-ios-Wap-聚力视频
   208000602030 ipad

   PC-Web我统一传：
   208000101005 PC-Mac-Web-PP视频
   208000103005 PC-Windows-Web-聚力视频

   PC客户端我统一传：
   208000101011 PC-Mac-PP视频客户端（pptv已经没有mac版客户端了，先保留吧）
   208000103011 PC-Windows-聚力视频客户端
 */
const CHANNEL_IOS = '208000201035';
const CHANNEL_IPAD = '208000602030';
const CHANNEL_ANDROID = '208000202035';
const CHANNEL_HUAWEI = '208000203035';
const TERMINAL_WAP = 'WAP';
const SCENE_WAP = 2;

const CHANNEL_WEB_WIN = '208000103005';
const CHANNEL_WEB_MAC = '208000101005';
const CHANNEL_CLIENT_WIN = '208000103011';
const CHANNEL_CLIENT_MAC = '208000101011';
const TERMINAL_PC = 'PC';
const SCENE_PC = 1;

// todo APP
function getComnParams() {
  let obj = {};
  // ios
  if (RUNTIME_ENV.ios) {
    obj = {
      channel: CHANNEL_IOS,
      terminal: TERMINAL_WAP,
      sceneFlag: SCENE_WAP,
    };
    console.log('ios');
    if (UA.toLowerCase().includes('ipad')) {
      console.log('ipad');
      obj.channel = CHANNEL_IPAD;
      obj.terminal = TERMINAL_PC;
      obj.sceneFlag = SCENE_PC;
    }
    return obj;
  }
  // android
  if (RUNTIME_ENV.android) {
    obj = {
      channel: CHANNEL_ANDROID,
      terminal: TERMINAL_WAP,
      sceneFlag: SCENE_WAP,
    };
    console.log('andriod');
    return obj;
  }

  // huawei
  if (RUNTIME_ENV.harmony) {
    obj = {
      channel: CHANNEL_HUAWEI,
      terminal: TERMINAL_WAP,
      sceneFlag: SCENE_WAP,
    };
    console.log('andriod');
    return obj;
  }


  // pc windows 浏览器
  if (RUNTIME_ENV.webWin) {
    obj = {
      channel: CHANNEL_WEB_WIN,
      terminal: TERMINAL_PC,
      sceneFlag: SCENE_PC,
    };
    console.log('webwin');
    return obj;
  }
  // pc mac 浏览器
  if (RUNTIME_ENV.webMac) {
    obj = {
      channel: CHANNEL_WEB_MAC,
      terminal: TERMINAL_PC,
      sceneFlag: SCENE_PC,
    };
    console.log('webmac');
    return obj;
  }
  // pc win 客户端
  if (RUNTIME_ENV.clientWin) {
    obj = {
      channel: CHANNEL_CLIENT_WIN,
      terminal: TERMINAL_PC,
      sceneFlag: SCENE_PC,
    };
    console.log('clientwin');
    return obj;
  }
  // pc mac 客户端
  if (RUNTIME_ENV.clientMac) {
    obj = {
      channel: CHANNEL_CLIENT_MAC,
      terminal: TERMINAL_PC,
      sceneFlag: SCENE_PC,
    };
    console.log('clientMac');
    return obj;
  }
  return obj;
}
const comnParams = getComnParams();

const key = '_dfp';
comnParams.dfpToken = window[key] && window[key].getToken();
comnParams.detect = (scene = '1') => window.bd && window.bd.rst({ scene });


// const platform = PLATFORM.Browser;
// const isBrowser = true;
// const isMobile = false;
// const RUNTIME_ENV = '';
// const isPPTVClient = false;
// const isSulinkClient = false;
// const isClient = false;
// const comnParams = {};

export {
  PLATFORM,
  platform,
  isBrowser,
  isMobile,
  RUNTIME_ENV,
  isPPTVClient,
  isSulinkClient,
  isClient,
  comnParams,
  CHANNEL_IOS,
  CHANNEL_IPAD,
  CHANNEL_ANDROID,
  CHANNEL_WEB_WIN,
  CHANNEL_WEB_MAC,
  CHANNEL_CLIENT_WIN,
  CHANNEL_CLIENT_MAC,
  CHANNEL_HUAWEI
};
